import { PessoaDTO } from './pessoa.dto';

export class PessoaJuridicaDTO {

    pessoaDTO: PessoaDTO = void (0);
    cdPessoa: number;
    nrCnpj: string;
    nmRazaoSocial: string;
    constructor(
        pessoaDTO?: PessoaDTO,
        cdPessoa?: number,
        nrCnpj?: string,
        nmRazaoSocial?: string
    ) {
        this.pessoaDTO = pessoaDTO;
        this.cdPessoa = cdPessoa;
        this.nrCnpj = nrCnpj;
        this.nmRazaoSocial = nmRazaoSocial;
    }
}